import { CanMarshal } from "src/app/shared-module/models/canMarshal.model"
import { CertificateType } from "./certificate-type.model"

export class AvailableCertificate extends CanMarshal<AvailableCertificate> {
	public name: string
	public type: CertificateType
	public slug?: string
	public uuid: string
}
